import React, { useState } from 'react'
import { Card, CardContent } from '../../ui/card'
import { Button } from '../../ui/button'
import { Label } from '../../ui/label'
import { DatePicker } from '../../ui/date-picker'
import { Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import { extractErrorMessage } from '@/common/extractErrorMessage'
import ReportEndpoints from '../../../endpoints/ReportEndpoints'
import { ReportViewer, useReportViewer } from '../ReportViewer'
import { rootUrl } from '../reportShared'

export const IdentityAuditLogPage: React.FC = () => {
  const { viewerProps, openReport, generating, setGenerating } = useReportViewer()

  const [startDate, setStartDate] = useState<Date | undefined>()
  const [endDate, setEndDate] = useState<Date | undefined>()

  const generate = async () => {
    if (!startDate || !endDate) { toast.error('Select a date range'); return }
    setGenerating(true)
    try {
      const res = await ReportEndpoints.getIdentityAuditLogReport({
        startDate: startDate.getTime() as any, endDate: endDate.getTime() as any, rootUrl,
      })
      openReport('Identity Audit Log', res)
    } catch (error) { toast.error(extractErrorMessage(error, 'Failed to generate report')) }
    finally { setGenerating(false) }
  }

  return (
    <>
      <Card className="max-w-3xl">
        <CardContent className="pt-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Start Date *</Label>
              <DatePicker date={startDate} onDateChange={setStartDate} placeholder="Start date" />
            </div>
            <div className="space-y-2">
              <Label>End Date *</Label>
              <DatePicker date={endDate} onDateChange={setEndDate} placeholder="End date" />
            </div>
          </div>
          <Button onClick={generate} disabled={generating}>
            {generating ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Generating...</> : 'Generate Report'}
          </Button>
        </CardContent>
      </Card>
      <ReportViewer {...viewerProps} />
    </>
  )
}
